
const global = {
    ROUTER_URL: "https://taxi.manage.yuntuzl.com/",
    HOME_MENUS: [
        {
            name:'营运管理',
            url:process.env.NODE_ENV === 'development'?
                'http://taxi.manage.test.yuntuzl.com:8888/operate'
                :
                'http://taxi.manage.yuntuzl.com/operate',
                // 'http://taxi.manage.test.yuntuzl.com:8888/operate',
            icon:'operate_icon.png'
        },
        // {
        //     name:'财务管理',
        //     url:process.env.NODE_ENV === 'development'?
        //         'http://192.168.18.201:8084/taxifee':'https://taxi.manage.yuntuzl.com/taxifee',
        //     icon:'/static/images/finance.png'
        // },
        {
            name:'发票管理',
            url:process.env.NODE_ENV === 'development'?
                'http://taxi.manage.test.yuntuzl.com:8888/invoice'
                :
                'https://taxi.manage.yuntuzl.com/invoice',
            // 'http://taxi.manage.test.yuntuzl.com:8888/invoice',
            icon:'invoice.png'
        },{
            name:'监控中心',
            url: process.env.NODE_ENV === 'development'?
                'javascript:alert(\'开发中，敬请期待\')':'javascript:alert(\'开发中，敬请期待\')',
            icon: 'monitor.png'
        },
        {
            name:'大数据中心',
            url: process.env.NODE_ENV === 'development'?
                'javascript:alert(\'开发中，敬请期待\')':'javascript:alert(\'开发中，敬请期待\')',
            icon:'bigdata.png'
        },
        {
            name:'OA管理',
            url: process.env.NODE_ENV === 'development'?
                'http://taxi.manage.test.yuntuzl.com:8888/oa'
                :
                'https://taxi.manage.yuntuzl.com/oa/#/login',
                // 'http://taxi.manage.test.yuntuzl.com:8888/oa',
            icon:'oa.png'
        },
        {
            name:'权限管理',
            url:process.env.NODE_ENV === 'development'?
                'http://taxi.manage.test.yuntuzl.com:8888/sso/#/casLogin'
                :
                'https://taxi.manage.yuntuzl.com/sso/#/casLogin',
                // 'http://taxi.manage.test.yuntuzl.com:8888/sso/#/casLogin',
            icon:'auth.png'
        }
    ],
}
export default global

